import React from 'react';
import classnames from 'classnames';
import { Icon } from './icon';
const customCache = new Set();
/**
 * @category 方法
 * @description 通过自定义 iconfont源来使用使用svg格式的图片
 */
export function createFromIconfontCN(options = {}) {
    const { scriptUrl, extraCommonProps = {} } = options;
    let hasExist = customCache.has(scriptUrl);
    if (document.querySelector(`script[data-namespace="${scriptUrl}"]`)) {
        hasExist = true;
    }
    /**
     * DOM API required.
     * Make sure in browser environment.
     * The Custom Icon will create a <script/>
     * that loads SVG symbols and insert the SVG Element into the document body.
     */
    if (typeof document !== 'undefined' &&
        typeof window !== 'undefined' &&
        typeof document.createElement === 'function' &&
        typeof scriptUrl === 'string' &&
        scriptUrl.length &&
        !hasExist) {
        const script = document.createElement('script');
        script.setAttribute('src', scriptUrl);
        script.setAttribute('data-namespace', scriptUrl);
        customCache.add(scriptUrl);
        document.body.appendChild(script);
    }
    const Iconfont = (props) => {
        const { type, size, children, className, outerClassName, rtl, ttb, ...others } = props;
        // component > children > type
        let content = null;
        if (props.type) {
            content = React.createElement("use", { xlinkHref: `#${type}` });
        }
        if (children) {
            content = children;
        }
        if (rtl) {
            // @ts-ignore
            others.dir = 'rtl';
        }
        if (ttb) {
            others.dir = 'ttb';
        }
        const classes = classnames('cn-ui-m-icon-remote', className);
        return (React.createElement(Icon, { className: outerClassName, type: type, size: size, ...others },
            React.createElement("svg", { className: classes, focusable: false, ...extraCommonProps }, content)));
    };
    Iconfont.displayName = 'Iconfont';
    return Iconfont;
}
